export default __webpack_public_path__ + "static/media/support-monitor.9139aecd.png";